import _objectSpread from "/srv/controlpanel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
var white = '#FFFFFF';
var black = '#0F131A';
var whites = {
  'white-medium': 'rgba(255, 255, 255, 0.90)',
  'white-solid': '#FFFFFF'
};
var darkPurples = {
  'purple-light-transparent': 'rgba(35, 22, 63, 0.05)',
  'purple-lightest': 'rgba(35, 22, 63, 0.34)',
  'purple-lighter': 'rgba(35, 22, 63, 0.44)',
  'purple-light': 'rgba(35, 22, 63, 0.64)',
  'purple-medium': 'rgba(35, 22, 63, 0.90)',
  'purple-solid': '#23163f',
  darkPurple: '#23163fd7'
};
var accentPurples = {
  'purple-accent-transparent': 'rgba(80, 83, 162, 0.05)',
  'purple-accent-extra-lightest': 'rgba(80, 83, 162, 0.25)',
  'purple-accent-lightest': 'rgba(80, 83, 162, 0.34)',
  'purple-accent-lighter': 'rgba(80, 83, 162, 0.44)',
  'purple-accent-light': 'rgba(80, 83, 162, 0.64)',
  'purple-accent-medium': 'rgba(80, 83, 162, 0.90)',
  'purple-accent-solid': '#5053A2'
};
var secondaryPurples = {
  'purple-secondary-transparent': 'rgba(149, 144, 158, 0.05)',
  'purple-secondary-extra-lightest': 'rgba(149, 144, 158, 0.25)',
  'purple-secondary-lightest': 'rgba(149, 144, 158, 0.34)',
  'purple-secondary-lighter': 'rgba(149, 144, 158, 0.44)',
  'purple-secondary-light': 'rgba(149, 144, 158, 0.64)',
  'purple-secondary-medium': 'rgba(149, 144, 158, 0.90)'
};
var greens = {
  'green-lightest': 'rgba(153, 188, 8, 0.34)',
  'green-lighter': 'rgba(153, 188, 8, 0.44)',
  'green-light': 'rgba(153, 188, 8, 0.64)',
  'green-medium': 'rgba(153, 188, 8, 0.90)',
  'green-solid': '#99BC08',
  'green-hover': '#668c00'
};
var blues = {
  'blue-highlight': 'rgba(60, 165, 217, 0.24)',
  'blue-lightest': 'rgba(60, 165, 217, 0.34)',
  'blue-lighter': 'rgba(60, 165, 217, 0.44)',
  'blue-light': 'rgba(60, 165, 217, 0.64)',
  'blue-medium': 'rgba(60, 165, 217, 0.90)',
  'blue-solid': '#3CA5D9',
  'blue-hover': '#0076a7'
};
var oranges = {
  'orange-lightest': 'rgba(246, 142, 32, 0.34)',
  'orange-lighter': 'rgba(246, 142, 32, 0.44)',
  'orange-light': 'rgba(246, 142, 32, 0.64)',
  'orange-medium': 'rgba(246, 142, 32, 0.90)',
  'orange-solid': '#F68E20'
};
var reds = {
  'red-lightest': 'rgba(232, 48, 27, 0.34)',
  'red-lighter': 'rgba(232, 48, 27, 0.44)',
  'red-light': 'rgba(232, 48, 27, 0.64)',
  'red-medium': 'rgba(232, 48, 27, 0.90)',
  'red-solid': '#E8301B',
  'red-hover': '#ad0000'
};
var grays = {
  'gray-label': '#D8D8D8',
  'gray-lightest': 'rgba(22, 36, 63, 0.02)',
  'gray-lighter': 'rgba(32, 24, 61, 0.04)',
  'gray-light': 'rgba(32, 24, 61, 0.08)',
  'gray-medium': 'rgba(32, 24, 61, 0.12)',
  'gray-solid': 'rgb(228, 227, 232)',
  'gray-hover': '#E4E3E8'
};
export var colors = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
  white: white,
  black: black,
  placeholder: 'rgba(0, 0, 0, 0.42)',
  defaultGray: '#23163fa3',
  inputPrintBorder: '#5C5271',
  wellGray: '#f3f2f7',
  disabledGray: '#23163f57',
  dividerGray: '#e3e2e7',
  controlBackground: 'rgba(240, 240, 242, 0.90)',
  hoverGray: 'rgba(241, 240, 243, 0.47)',
  transparent: 'transparent',
  defaultBoxShadow: '#20183d1e',
  lightenGray: '#20183d0a',
  lightGray: '#23163f70',
  lightPurple: '#e4e3e8',
  divider: 'rgb(227, 226, 231)'
}, grays), whites), darkPurples), accentPurples), secondaryPurples), greens), blues), oranges), reds);
export var fontWeights = {
  normal: 400,
  semibold: 600,
  bold: 700
};
export var borderRadius = {
  kilo: '1px',
  mega: '4px',
  giga: '5px'
};
export var fontsStack = {
  default: "'Open Sans', sans-serif;"
};
export var fontsSize = {
  'x-small': '12px',
  small: '14px',
  medium: '17px',
  large: '20px'
};
export var iconsSize = {
  small: '24px',
  medium: '32px',
  large: '40px'
};
var defaultSize = {
  size: 'small'
};
export var getFontSize = function getFontSize() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultSize,
      size = _ref.size;

  try {
    return fontsSize[size];
  } catch (e) {
    return fontsSize.small;
  }
};
export var getIconSize = function getIconSize() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultSize,
      size = _ref2.size;

  try {
    return iconsSize[size];
  } catch (e) {
    return iconsSize.small;
  }
};
export var getBackgroundColor = function getBackgroundColor(_ref3) {
  var type = _ref3.type;

  switch (type) {
    case 'danger':
      return colors['red-solid'];

    case 'success':
      return colors['green-solid'];

    case 'info':
      return colors['blue-solid'];

    default:
      return colors['gray-light'];
  }
};
export var spacings = {
  bit: '5px',
  byte: '8px',
  kilo: '12px',
  mega: '17px',
  giga: '24px',
  tera: '40px',
  peta: '48px',
  exa: '56px',
  zetta: '96px'
};
export var getButtonBasedWidthAndHeight = function getButtonBasedWidthAndHeight(_ref4) {
  var size = _ref4.size,
      variant = _ref4.variant;
  var isFab = ['fab', 'extendedFab'].includes(variant);
  var minWidth = '128px';

  switch (size) {
    case 'medium':
      return "\n        min-height: ".concat(spacings.peta, ";\n        min-width: ").concat(isFab ? spacings.peta : minWidth, ";\n      ");

    case 'large':
      return "\n        min-height: ".concat(spacings.exa, ";\n        min-width: ").concat(isFab ? spacings.exa : minWidth, ";\n      ");

    case 'xLarge':
      return "\n        min-height: ".concat(spacings.zetta, ";\n        min-width: ").concat(isFab ? spacings.zetta : minWidth, ";\n      ");

    default:
      return "\n        min-height: ".concat(spacings.tera, ";\n        min-width: ").concat(isFab ? spacings.tera : minWidth, ";\n      ");
  }
};
export var getControlSize = function getControlSize(_ref5) {
  var size = _ref5.size;

  switch (size) {
    case 'medium':
      return "min-height: ".concat(spacings.peta);

    case 'large':
      return "min-height: ".concat(spacings.exa);

    default:
      return "min-height: ".concat(spacings.tera);
  }
};
export var getBasicInputSize = function getBasicInputSize(_ref6) {
  var size = _ref6.size;

  switch (size) {
    case 'medium':
      return "height: ".concat(spacings.peta);

    case 'large':
      return "height: ".concat(spacings.exa);

    default:
      return "height: ".concat(spacings.tera);
  }
};
export var getPaddingBaseOnSize = function getPaddingBaseOnSize(_ref7) {
  var size = _ref7.size;

  switch (size) {
    case 'small':
      return "padding: ".concat(spacings.bit);

    default:
      return "padding: ".concat(spacings.byte);
  }
};